import { z } from "zod";

export const complaintSchema = z.object({
  lastName: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),

  firstName: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),
  city: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),
  phone: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" })
    .regex(/^(?:\+33|0)[1-9](?:[0-9]{8})$/, {
      message: "Le numéro de téléphone doit être un numéro français valide (ex: 0123456789 ou +33123456789)",
    }),

  subject: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),
  company: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),
  message: z
    .string({ required_error: "Ce champ est obligatoire" })
    .min(1, { message: "Ce champ est obligatoire" }),
  email: z
    .string({ required_error: "Ce champ est obligatoire" })
    .email({ message: "Ce champ est obligatoire" }),
  terms: z
    .boolean({ required_error: "Vous devez accepter les termes et conditions" })
    .refine((val) => val === true, {
      message: "Vous devez accepter les termes et conditions",
    }),
});

export type ProjectComplaintValues = z.infer<typeof complaintSchema>;

export const updateComplaintSchema = z
  .object({
    lastName: z.string().min(1, { message: "Ce champ est obligatoire" }),
    firstName: z.string().min(1, { message: "Ce champ est obligatoire" }),
    receiver: z.string().min(1, { message: "Selectionner une rôle" }),
    subject: z.string().min(1, { message: "Ce champ est obligatoire" }),
    company: z.string().min(1, { message: "Ce champ est obligatoire" }),
    message: z.string().min(1, { message: "Ce champ est obligatoire" }),
    email: z.string().email({ message: "Ce champ est obligatoire" }),
  })
  .partial();

export type UpdateComplaintFormValues = z.infer<typeof updateComplaintSchema>;
